/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {TopStatsTableComponent} from '../controller/top-stats-table.component';

@Component({
  standalone: true,
  imports: [TopStatsTableComponent],
  selector: 'adn-top-stats-table-host',
  template: `
    <adn-top-stats-table
      [object]="object"
      [parentType]="parentType"
      [childType]="childType">
    </adn-top-stats-table>
  `
})
export class TopStatsTableHostComponent {
  @Input() object: any;
  @Input() parentType: string;
  @Input() childType: string;
}
